// Auswahlfeld neben dem Kaufknopf. Es setzt dieselbe Menge wie die Kacheln
// darueber -- die Kacheln sind die haeufigen Griffe, das Feld deckt alle
// Mengen ab. Quelle der Wahrheit bleiben die Radioknoepfe im Formular, damit
// die Seite auch ohne JavaScript eine vollstaendige Bestellung abschickt.
if (!customElements.get('gebinde-menge')) {
  // Beim Variantenwechsel ersetzt product-rerender (theme.js) das ganze
  // <buy-buttons> und rettet dabei nur den Vendor-<quantity-selector>. Die
  // Gebinde-Radios kaemen sonst mit dem Liquid-Vorgabewert zurueck: wer 12
  // gewaehlt und dann den Jahrgang gewechselt hat, bestellte still 1.
  // Merkt sich deshalb je Formular die zuletzt gewaehlte Menge.
  const zuletztGewaehlt = new Map();
  const vorausgewaehlt = new Set();

  customElements.define(
    'gebinde-menge',
    class extends HTMLElement {
      connectedCallback() {
        this.feld = this.querySelector('select');
        if (!this.feld) return;

        this.formular = this.feld.id.replace(/^Gebinde-/, '');
        // Ohne Formular-ID traefe der Selektor [form=""] nie, und das Feld
        // waere still ohne Wirkung.
        if (!this.formular) return;

        // Paket-Kacheln tauschen die Variante: das id-Feld zeigt dann auf das
        // Paket-Produkt. Das Auswahlfeld zaehlt immer Flaschen.
        this.idFeld = document.getElementById(this.formular)?.querySelector('input[name="id"]');
        // Paket-Kacheln kommen gesperrt aus Liquid (ohne JavaScript bestellten sie eine Flasche).
        if (this.idFeld) {
          this.pakete.forEach((knopf) => { knopf.disabled = false; });
        }
        this.flaschenId = this.idFeld?.value;

        // Steht die Vorauswahl (Block "Kaufknoepfe") auf einer Spezialangebot-Kachel,
        // kommt sie aus Liquid schon angehakt; das id-Feld zeigt aber noch auf die Flasche.
        const paketVorgabe = document.querySelector(`input[form="${this.formular}"][data-paket-variante]:checked`);
        if (paketVorgabe) this.paketWaehlen(paketVorgabe);

        const gemerkt = zuletztGewaehlt.get(this.formular);
        if (gemerkt) this.setzen(gemerkt);
        // Nach einem Neuaufbau steht im Feld wieder der Vorgabewert aus
        // Liquid. Der angehakte Knopf ist der echte Stand.
        this.uebernehmen();

        this.feld.addEventListener('change', () => this.mengeWaehlen(this.feld.value));
        document.addEventListener('change', this.aufKnopf = (e) => {
          // Nur die Radios des eigenen Formulars: der Schnellkauf eines anderen
          // Produkts hat sein eigenes <gebinde-menge> am selben Dokument.
          if (e.target.name === 'quantity' && e.target !== this.feld && e.target.getAttribute('form') === this.formular) {
            if (e.target.dataset.paketVariante) return this.paketWaehlen(e.target);
            if (this.paket) this.flaschenWaehlen();
            zuletztGewaehlt.set(this.formular, e.target.value);
            this.uebernehmen();
          }
        });

        this.vorauswahl();
      }

      // Link /products/<wein>#6er waehlt sechs Flaschen vor: das Spezialangebot,
      // wenn es eins gibt, sonst die normale Menge. Nur beim ersten Aufbau, sonst
      // holte ein Neuaufbau nach dem Variantenwechsel den Link ueber die Kundenwahl zurueck.
      vorauswahl() {
        // Der Link meint das Hauptformular, nicht einen spaeter geoeffneten Schnellkauf.
        if (this.closest('quick-buy-modal, .quick-buy')) return;
        if (vorausgewaehlt.has(this.formular)) return;
        vorausgewaehlt.add(this.formular);
        const menge = location.hash.match(/^#(\d+)er$/i)?.[1];
        if (menge) this.mengeWaehlen(menge);
      }

      // 6 und 12 Flaschen und ihre Vielfachen gehen als Spezialangebot in den
      // Warenkorb, solange genug Pakete da sind (24 = 2 x 12er), sonst als Flaschen.
      mengeWaehlen(wert) {
        const flaschen = Number(wert);
        const paket = this.idFeld && [...this.pakete]
          .sort((a, b) => b.dataset.flaschen - a.dataset.flaschen)
          .find((knopf) => flaschen % knopf.dataset.flaschen === 0 && flaschen / knopf.dataset.flaschen <= (Number(knopf.dataset.paketMax) || 1));
        if (!paket) return this.setzen(wert);
        // Vorher setzen, sonst stellt paketWaehlen die Anzahl auf ein Paket zurueck.
        this.paket = paket;
        paket.value = String(flaschen / paket.dataset.flaschen);
        paket.checked = true;
        paket.dispatchEvent(new Event('change', { bubbles: true }));
      }

      disconnectedCallback() {
        document.removeEventListener('change', this.aufKnopf);
      }

      get knoepfe() {
        return document.querySelectorAll(`input[type="radio"][name="quantity"][form="${this.formular}"]:not([data-paket-variante])`);
      }

      get pakete() {
        return document.querySelectorAll(`input[form="${this.formular}"][data-paket-variante]`);
      }

      paketWaehlen(knopf) {
        if (!this.idFeld) return;
        // Ein Klick auf die Kachel beginnt immer bei einem Paket, nicht bei der Zahl von zuvor.
        if (this.paket !== knopf) knopf.value = '1';
        this.paket = knopf;
        this.idFeld.value = knopf.dataset.paketVariante;
        this.feld.value = String(knopf.dataset.flaschen * knopf.value);
        this.melden();
      }

      flaschenWaehlen() {
        this.paket = null;
        if (this.idFeld && this.flaschenId) this.idFeld.value = this.flaschenId;
        this.melden();
      }

      // Das change der Kachel erreicht das Formular, bevor hier die Variante
      // getauscht ist; die Summenzeile rechnet danach noch einmal.
      melden() {
        this.idFeld?.form?.dispatchEvent(new Event('gebinde:change'));
      }

      uebernehmen() {
        const gewaehlt = [...this.knoepfe].find((knopf) => knopf.checked);
        if (gewaehlt && this.feld.value !== gewaehlt.value) this.feld.value = gewaehlt.value;
      }

      setzen(wert) {
        if (this.paket) this.flaschenWaehlen();
        const treffer = [...this.knoepfe].find((knopf) => knopf.value === wert);
        // Eine Menge, die es bei dieser Variante nicht gibt, bleibt unbeachtet;
        // dann gilt der Vorgabewert aus Liquid.
        if (!treffer) return;
        zuletztGewaehlt.set(this.formular, wert);
        if (treffer.checked) return;
        treffer.checked = true;
        treffer.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  );
}
